import get from 'lodash.get';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import styles from './styles/CheckoutDeposit.scss';

// components
import DepositLink from 'dibs-buyer-deposit/exports/DepositLink';
import depositTracking from 'dibs-buyer-deposit/exports/depositTracking';
import DepositsAccepted from 'dibs-buyer-deposit/src/messages/DepositsAccepted';
import DepositShortCopy from 'dibs-buyer-deposit/src/messages/DepositShortCopy';
import InitiateDepositRequest from 'dibs-buyer-deposit/src/messages/InitiateDepositRequest';
import CheckoutComponentLoader from '../containers/CheckoutComponentLoader';

class CheckoutDeposit extends Component {
    constructor(props) {
        super(props);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.state = { isModalOpen: false };
    }
    onOpenModal() {
        this.setState({ isModalOpen: true });
    }
    onCloseModal() {
        depositTracking.trackClose();
        this.setState({ isModalOpen: false });
    }
    render() {
        const { isModalOpen } = this.state;
        const { relay, transaction } = this.props;
        return (
            transaction.isDepositAvailable && (
                <div className={styles.wrapper}>
                    <div className={styles.header}>
                        <DepositsAccepted />
                    </div>
                    <div className={styles.body}>
                        <DepositShortCopy />
                    </div>
                    <DepositLink linkText={<InitiateDepositRequest />} onClick={this.onOpenModal} />
                    {isModalOpen && (
                        <CheckoutComponentLoader
                            {...{
                                isOpen: isModalOpen,
                                environment: relay.environment,
                                itemId: get(transaction, 'item.serviceId'),
                                buyerId: get(transaction, 'buyer.serviceId'),
                                onClose: this.onCloseModal,
                            }}
                            importFunc={() =>
                                import(
                                    /* webpackChunkName: "DepositModal" */
                                    '../../shared/deposits/DepositModal'
                                )
                            }
                            hideLoader
                        />
                    )}
                </div>
            )
        );
    }
}

CheckoutDeposit.propTypes = {
    relay: PropTypes.object.isRequired,
    transaction: PropTypes.object.isRequired,
};

export const CheckoutDepositComponent = CheckoutDeposit;

export default createFragmentContainer(CheckoutDeposit, {
    transaction: graphql`
        fragment CheckoutDeposit_transaction on Transaction {
            isDepositAvailable
            item {
                serviceId
            }
            buyer {
                serviceId
            }
        }
    `,
});
